import React from 'react';
import PropTypes from 'prop-types';
import PropertyDetailUtilitiesSection from '../../PropertyDetailUtilitiesSection/PropertyDetailUtilitiesSection';
import DescriptionOfCapability from './DescriptionOfCapability';
import isObjectNullOrEmpty from './isObjectNullOrEmpty';

import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

const TelecommunicationsSubSectionDetail = ({ util, title }) => (
  <section>
    <ViewerPrimaryColorUserStyle domStyle="color">
      <h4 className="section-title">{title}</h4>
    </ViewerPrimaryColorUserStyle>

    { util.map((provider, i) => {
      return (
        <div className="section-body" key={i}>
          <ul key={i + 1}>
            <PropertyDetailUtilitiesSection util={provider} />

            {!isObjectNullOrEmpty(provider, ['platforms']) &&
            <li><strong>Platforms: </strong>
              {provider.platforms === '1' && 'Fiber'}
              {provider.platforms === '2' && 'Cable'}
              {provider.platforms === '3' && 'DSL'}
              {provider.platforms === '4' && 'Fixed Wireless'}
              {provider.platforms === '5' && 'Mobile Wireless'}
            </li>
            }
            {!isObjectNullOrEmpty(provider, ['serviceSpeedAndRedundancy']) &&
            <li><strong>Service Speed & Redundancy: </strong>
              {provider.serviceSpeedAndRedundancy === '1' && 'Greater than 1 Gbps'}
              {provider.serviceSpeedAndRedundancy === '2' && '100 Mbps to < 1'}
              {provider.serviceSpeedAndRedundancy === '3' && '50 Mbps to < 100'}
              {provider.serviceSpeedAndRedundancy === '4' && '25 Mbps to < 50'}
              {provider.serviceSpeedAndRedundancy === '5' && '10 Mbps to < 25'}
              {provider.serviceSpeedAndRedundancy === '6' && '6 Mbps to < 10'}
              {provider.serviceSpeedAndRedundancy === '7' && '3 Mbps to < 6 Mbps'}
              {provider.serviceSpeedAndRedundancy === '8' && '1.5 Mbps to < 3 Mbps'}
              {provider.serviceSpeedAndRedundancy === '9' && '768 kbps to < 1.5 Mbps'}
            </li>
            }
          </ul>
          <DescriptionOfCapability util={provider} />
        </div>
      );
    })
    }
  </section>
);

TelecommunicationsSubSectionDetail.propTypes = {
  title: PropTypes.string,
  util: PropTypes.arrayOf(PropTypes.object),
};

export default TelecommunicationsSubSectionDetail;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailUtilities/SubUtilityDetailsSections/TelecommunicationsSubSectionDetail.js